import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Shimmer } from "react-shimmer";
import { ImagePath } from "../../../assets/ImagePath";
import { useDispatch, useSelector } from "react-redux";
import { getAuthData } from "../../../services/storage/LocalStorage";
import { useNavigate } from "react-router-dom";
import { removeBot, setSelectedBot } from "../../../state/actions/domain";
import { clearSelectedConversation, createConversation } from "../../../state/actions/chats";
import { setHideDefaultHomepageBot } from "../../../state/actions/bot";
import { withOutInitSocket } from "../../../state/actions/socket";
import { createConversationId } from "../../../utils/conversationUtils";
import { setBotWaitLoader } from "../../../state/actions/loader";
// import { sendToNative } from "../../../utils/general";


const MobileBanner = ({ isBannersLoading }) => {
  const mobileBanners = useSelector((state) => state?.domain.selectedDomainDetails.webBanners);
  console.log("mobileBanners => ", mobileBanners);
  const [loadingImages, setLoadingImages] = useState(new Set());
  const authData = getAuthData();
   const bots = useSelector((state) => state?.user?.botSubscriptions);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const bannerClickHandler = async (value) => {
    // const message = {
    //   type: 'banner_click',
    //   value: banner,
    //   timestamp: new Date().toISOString()
    // };
    console.log("bannerClickHandler:", value);
    // sendToNative("handleBannerClick", message);

    const userId = authData?.user?.userId;
    
          const redirectMap = {
            Apps: "/app/catalog",
            Contacts: "/app/contacts",
            myProfileScreenOnship: "/app/my-profile",
          };
    
          const target = redirectMap[value?.data];
    
          if (target) {
            // Clear selected bot and conversation state before navigating
            dispatch(removeBot());
            dispatch(clearSelectedConversation());
            dispatch(setHideDefaultHomepageBot());
            navigate(target);
          }
          else if (value?.type === "bot") {
            if (!bots || bots.length === 0) return;
    
            dispatch(setHideDefaultHomepageBot());
            dispatch(withOutInitSocket(true));
    
            const botDetails = bots.find(
              (bot) => bot?.botId === value?.data
            );
    
            if (botDetails) {
              const userDomain = botDetails.userDomain;
    
              const conversationId = await createConversationId(
                userId,
                value?.data
              );
    
              dispatch(
                createConversation(
                  userId,
                  value?.data,
                  userDomain
                )
              );
    
              startConversation(userId, {
                conversationId,
                botId: value?.data,
                userDomain,
              });
    
              dispatch(setBotWaitLoader(true));
              dispatch(setSelectedBot(botDetails));
            }
          }
  };

  useEffect(() => {
    if (!mobileBanners?.length) return;

    const loadImages = async () => {
      const loading = new Set();
      setLoadingImages(loading);

      const promises = mobileBanners?.map(async (banner) => {
        if (!banner.image) return null;

        loading.add(banner.image);

        try {
          // Create a new image to preload
          const img = new Image();
          await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = banner.image;
          });

          return banner.image; // Use direct URL for now
        } catch (error) {
          console.error("Failed to load image:", banner.image, error);
          return banner.image; // Fallback to original URL
        }
      }).filter(Boolean);

      await Promise.all(promises);
      setLoadingImages(new Set());
    };

    loadImages();
  }, [mobileBanners]);


  if (isBannersLoading) {
    return (
      <div className="relative sm:w-full w-full xl:h-60 sm:h-48 h-[320px] md:h-56">
        <Shimmer className="!w-[607px] !h-[225px] rounded-2xl" />
      </div>
    );
  }

  // Case 2: No banners after loading
  if (mobileBanners?.length === 0) {
    return (
      <div className="relative w-[607px] h-[225px] mb-3">
        <img
          src={ImagePath.crewMatterStaticBanner}
          alt="Banner-static"
          className="w-full h-full object-cover rounded-2xl select-none pointer-events-none"
          draggable={false}
        />
      </div>

    );
  }

  return (
    <div className="w-[749px] sm:mt-0 px-[71px] text-center">
      <Swiper
        spaceBetween={20}
        centeredSlides={true}
        autoplay={{ delay: 8000, disableOnInteraction: false }}
        loop={true}
        speed={1500}
        modules={[Autoplay]}
        className="mySwiper"
      >
        {mobileBanners?.map((banner, index) => (
          <SwiperSlide key={banner.image || index}>
            <div
              className="flex-shrink-0 w-[607px] h-[225px] snap-center snap-always cursor-pointer"
              onClick={() => bannerClickHandler(banner)}
            >
              <div className="relative w-full h-full rounded-[12.44px] overflow-hidden">
                {/* Show shimmer while image is loading */}
                {loadingImages.has(banner.image) && (
                  <div className="absolute inset-0 z-10">
                    <Shimmer className="!w-[607px] !h-[225px] rounded-2xl" />
                  </div>
                )}
                <img
                  src={banner.image}
                  alt={`Banner ${index + 1}`}
                  className={`w-full h-full object-fill object-left rounded-2xl select-none transition-opacity duration-300 ${loadingImages.has(banner.image) ? "opacity-0" : "opacity-100"
                    }`}
                  draggable={false}
                  onLoad={() => {
                    setLoadingImages(prev => {
                      const newSet = new Set(prev);
                      newSet.delete(banner.image);
                      return newSet;
                    });
                  }}
                  onError={() => {
                    console.error("Failed to load banner image:", banner.image);
                    setLoadingImages(prev => {
                      const newSet = new Set(prev);
                      newSet.delete(banner.image);
                      return newSet;
                    });
                  }}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MobileBanner;